const data = {
  privacy: `# 개인정보처리방침

* ‘CacheBy’을 운영하는 주식회사 데이터씨(이하 '회사')는 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’), 개인정보보호법 등 관련 법에 따라 이용자의 개인정보 보호 및 권익을 보호하고 개인정보와 관련한 이용자의 고충을 원활하게 처리할 수 있도록 다음과 같은 처리방침을 두고 있습니다.
* 회사는 개인정보처리방침을 개정하는 경우 홈페이지를 통하여 공지합니다.
* 본 방침은 2019년 8월 1일부터 시행됩니다.

## 1. 개인정보 수집 목적 및 항목

* 회사는 다음의 목적을 위해 개인정보를 처리합니다.

<table class="MsoTableGrid" border="1" cellspacing="0" cellpadding="0" width="1200" style="margin-left:5.4pt;border-collapse:collapse;border:none">
 <tbody><tr style="height:16.15pt">
  <td width="153" style="width:115.1pt;border:solid #BFBFBF 1.0pt;background:
  white;padding:0cm 5.4pt 0cm 5.4pt;height:16.15pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><b><span>목적</span></b></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border:solid #BFBFBF 1.0pt;
  border-left:none;background:white;padding:0cm 5.4pt 0cm 5.4pt;height:16.15pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><b><span>구분</span></b></p>
  </td>
  <td width="255" style="width:191.4pt;border:solid #BFBFBF 1.0pt;border-left:
  none;background:white;padding:0cm 5.4pt 0cm 5.4pt;height:16.15pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><b><span>필수항목</span></b></p>
  </td>
  <td width="85" style="width:63.75pt;border:solid #BFBFBF 1.0pt;border-left:
  none;background:white;padding:0cm 5.4pt 0cm 5.4pt;height:16.15pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><b><span>선택항목</span></b></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="153" rowspan="6" style="width:115.1pt;border:solid #BFBFBF 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:19.0pt;text-autospace:ideograph-numeric ideograph-other;
  vertical-align:baseline;word-break:keep-all"><span style="color:black;
  letter-spacing:-.25pt">서비스 회원가입</span></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>회원가입 </span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="text-align:left;line-height:normal;word-break:keep-all">
  이메일, 비밀번호, 상호/법인명/대학교명, 아이디, 연락처, 사업자등록번호
  </p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="142" rowspan="3" style="width:106.3pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>소셜회원가입</span></p>
  </td>
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>네이버</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이름, 이메일, 프로필사진, 아이디</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>구글</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이름, 이메일, 아이디</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>페이스북</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이름, 이메일, 프로필사진, 아이디</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>가입인증</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이메일</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>법인<span lang="EN-US">(</span>파트너<span lang="EN-US">) </span>가입</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">아이디, 회사이메일, 상호/법인명/대학교명, 브랜드명, 홈페이지, 로고</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="153" rowspan="3" style="width:115.1pt;border:solid #BFBFBF 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:19.0pt;vertical-align:baseline"><span style="color:black;letter-spacing:-.25pt">회원관리</span></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>로그인 인증</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이메일, 비밀번호</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>회원 프로필 관리</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">상호/법인명/대학교명, 연락처, 사업자등록번호, 프로필 이미지, 회사소개
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>부정이용 방지</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all">이메일</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="153" rowspan="9" style="width:115.1pt;border:solid #BFBFBF 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:19.0pt;vertical-align:baseline"><span style="color:black;letter-spacing:-.25pt">재화 또는 <span lang="EN-US"><br>
  </span>서비스의 제공</span></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>제품 문의하기</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름, 회사, 핸드폰번호, 이메일</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:3.0pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>재화 또는 서비스 제공</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>포스트, 주문내역, 후기
  </span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:3.0pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="142" rowspan="3" style="width:106.3pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>상품결제 </span></p>
  </td>
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>신용카드</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">카드사, 카드번호<span lang="EN-US">(</span>일부<span lang="EN-US">)</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>연구비카드</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">카드사, 카드번호<span lang="EN-US">(</span>일부<span lang="EN-US">)</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="113" style="width:3.0cm;border-top:none;border-left:none;border-bottom:
  solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;padding:0cm 5.4pt 0cm 5.4pt;
  height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>무통장입금</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">은행, 계좌번호, 예금주</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>환불처리</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">은행, 계좌번호, 예금주</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>현금영수증 발급</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">핸드폰번호, 현금영수증번호</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:14.95pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" style="line-height:
  normal;word-break:keep-all"><span>상품배송</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">주문자, 연락처, 사업자등록번호, 배송지 정보</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:14.95pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span>유선연락처</span></p>
  </td>
 </tr>
 <tr style="height:11.55pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.55pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>서비스 품질향상 및 상품 개발</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.55pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal">이름, 아이디, 서비스 이용기록</p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:11.55pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:18.75pt">
  <td width="153" style="width:115.1pt;border:solid #BFBFBF 1.0pt;border-top:
  none;padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:19.0pt;text-autospace:ideograph-numeric ideograph-other;
  vertical-align:baseline;word-break:keep-all"><span style="color:black;
  letter-spacing:-.25pt">이용자 민원 및 고충 처리</span></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>문의대응</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름, 회사, 핸드폰번호</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:18.75pt">
  <td width="153" rowspan="4" style="width:115.1pt;border:solid #BFBFBF 1.0pt;
  border-top:none;padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:19.0pt;text-autospace:ideograph-numeric ideograph-other;
  vertical-align:baseline;word-break:keep-all"><span style="color:black;
  letter-spacing:-.25pt">마케팅 및 이벤트 활용</span></p>
  </td>
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>광고성 정보 발송</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름, 이메일</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:18.75pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이벤트 및 경품배송</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름, 이메일, 핸드폰번호, 주소</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:18.75pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>오프라인 마케팅</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름, 이메일, 핸드폰번호</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
 <tr style="height:18.75pt">
  <td width="255" colspan="2" style="width:191.35pt;border-top:none;border-left:
  none;border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>블로그 등 온라인 마케팅 진행</span></p>
  </td>
  <td width="255" style="width:191.4pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="left" style="
  text-align:left;line-height:normal;word-break:keep-all"><span>이름<span lang="EN-US">, SNS ID, </span>이메일<span lang="EN-US">,
  </span>핸드폰번호</span></p>
  </td>
  <td width="85" style="width:63.75pt;border-top:none;border-left:none;
  border-bottom:solid #BFBFBF 1.0pt;border-right:solid #BFBFBF 1.0pt;
  padding:0cm 5.4pt 0cm 5.4pt;height:18.75pt">
  <p class="MsoNormal" align="center" style="
  text-align:center;line-height:normal"><span lang="EN-US">-</span></p>
  </td>
 </tr>
</tbody></table>


* 회사가 처리하는 회원정보의 목적과 항목이 변경될 경우에는 관련법령에 따라 사전에 동의를 요청합니다.
* 회사는 주민등록번호 처리를 원칙적으로 금지하며 업무 수행 중 법률, 대통령령, 국회규칙, 대법원규칙, 헌법재판소규칙, 중앙선거관리위원회 규칙 및 감사원규칙에서 구체적으로 주민등록번호의 처리를 요구할 경우에만 처리하고 있습니다.

## 2. 개인정보의 보유 및 이용 기간

* 관련법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보 수집 시에 동의 받은 개인정보 보유·이용기간 내에서 개인정보를 보유·이용합니다.
* 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.


| **보유 목적** | **기간** | **보유 근거** |
| --- | --- | --- |
| 거래내역 및 증빙서류와 관련된 정보 | 5년  | 국세기본법, 법인세법 |
| 표시•광고에 관한 기록 | 6개월 | 전자상거래 등에서의 소비자보호에 관한 법률 |
| 계약 또는 청약철회 등에 관한 기록 | 5년  | 전자상거래 등에서의 소비자보호에 관한 법률 |
| 대금결제 및 재화 등의 공급에 관한 기록 | 5년  | 전자상거래 등에서의 소비자보호에 관한 법률 |
| 소비자의 불만 또는 분쟁처리에 관한 기록 | 3년  | 전자상거래 등에서의 소비자보호에 관한 법률 |
| 접속에 관한 기록보존 | 3개월 | 통신비밀보호법 |
| 상법 등 관련법령에 따라 보존할 필요성이 있는 경우 | 10년 | 상법  |

## 3. 개인정보의 처리 위탁

* 회사는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.

| **수탁자** | **위탁업무** | **연락처** |
| --- | --- | --- |
| Amazon Web Service | 클라우드 서비스를 이용한 시스템 운영 및 데이터 보관 | aws-korea-privacy@amazon.com |
| 스티비 주식회사 | 뉴스레터 발송 | support@stibee.com |
| 주식회사 조이코퍼레이션 | 실시간 문의응대 서비스 | privacy@zoyi.co |
| 토스페이먼츠 주식회사 | 신용카드 및 전체 결제 서비스 | support@tosspayments.com |
| 유파운드(주) | 연구비카드 결제 서비스 | sales@ufound.co.kr |

* 회사는 위탁 계약 체결 시 관련법령에 따라 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.
* 위탁업무의 내용이나 수탁자가 추가, 변경될 경우에는 지체 없이 관련 법령에 따른 사전 동의 안내 또는 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

## 4. 개인정보의 제3자 제공에 관한 사항

* 회사는 정보주체의 개인정보를 ‘1. 개인정보 수집 목적 및 항목’에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.
* 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.

| **제공받는 자** | **제공목적** | **제공항목** | **보유 및 이용기간** |
| --- | --- | --- | --- |
| 제품등록 파트너사 | 문의 대응 | 이름, 상호/법인명/대학교명, 핸드폰번호, 문의내용 | 계약종료 시 |
| 제품등록 파트너사 | 상품 배송 | 이름, 이메일주소, 상호/법인명/대학교명, 전화번호, 배송 받는 주소, 요청사항(선택사항) |

* 회사는 이용자의 개인정보를 사전동의 없이 제 3자에게 제공할 수 없습니다. 다만 다음의 경우에는 예외로 합니다.
  - 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우
  - 관계법령에 의하여 국가기관으로부터 요구받은 경우
  - 범죄에 대한 수사상의 목적이 있거나, 정보통신 윤리위원회의 요청이 있는 경우
  - 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우

## 5. 이용자의 권리와 의무 및 그 행사방법

+ 이용자 및 법정대리인은 등록되어 있는 이용자 본인 혹은 당해 만 14세 미만자의 개인정보 관련하여, 다음과 같은 권리를 행사할 수 있습니다.
  - 서면, 전자우편, 홈페이지 등을 통하여 개인정보 처리 정지 및 삭제를 요구할 수 있습니다.
  - 개인정보의 오류 등에 대한 정정 또는 삭제를 요청한 경우에는 정정 또는 삭제를 완료하기 전까지 당해 개인정보를 이용하거나 제공하지 않습니다.
* 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다
* 이용자 권리 행사(열람, 정정, 처리정지, 삭제)는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출해야 합니다.
* 개인정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다.
+ 이용자는 개인정보주체로서 다음과 같은 의무를 가집니다.
  - 이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게 있습니다.
  - 이용자는 계정 등에 대해 보안을 유지할 책임이 있으며 제3자에게 이를 양도하거나 대여할 수 없습니다.
  - 타인의 개인정보를 도용하여 서비스 신청 시 이용자격 상실과 함께 관계법령에 의거하여 처벌될 수 있습니다.

## 6. 개인정보의 파기

+ 회사는 원칙적으로 개인정보 처리목적이 달성된 경우에는 지체 없이 해당 개인정보를 파기합니다. 파기의 절차 및 방법은 다음과 같습니다.
  + 파기절차
      - 이용자가 입력한 정보는 목적 달성 후 즉시 파기합니다. 다만, 1년간 서비스를 이용하지 않은 회원은 이를 사전에 고지하고, 이용자의 별도의 요청이 없는 경우 고지하고 이용자의 별도의 요청이 없는 경우 복구할 수 없는 방법으로 완전삭제합니다.
  + 파기방법
      - 전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
      - 종이에 출력된 개인정보는 파쇄기를 통하여 파기합니다.

## 7. 개인정보 자동 수집 장치의 설치와 운영 및 거부에 관한 사항

* 서비스 이용과정이나 개인정보 처리과정에서 다음과 같은 정보들이 자동으로 생성/수집되고 다음의 목적으로 이용될 수 있습니다.
* 자동생성정보 : 방문일시, 서비스 이용기록, 접속IP정보, 접속 로그, 쿠키(쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자 PC 컴퓨터의 하드디스크에 저장되기도 합니다.)
  + 자동생성정보의 사용목적:
    - 이용자에게 최적화된 정보 제공
    - 개인 맞춤형 상품 광고 및 마케팅
    - 서비스 제공 관련 고객상담, 민원처리 등의 목적
    - 정보통신망법 상 기록 의무 준수
  + 쿠키의 설치∙운영 및 거부 방법 : 아래 방법을 통해 쿠키 저장을 거부 할 수 있습니다.
    - Internet Explorer의 경우 : 웹브라우저 상단의 도구 >인터넷 옵션 >개인정보 메뉴의 옵션 설정
    - Microsoft Edge의 경우 : 웹브라우저 상단 메뉴 > 설정 > 고급 설정 보기 > 쿠키 메뉴의 옵션 설정
    - Chrome의 경우 : 웹브라우저 상단 메뉴 > 설정 > 고급 > 콘텐츠 설정 > 쿠키 메뉴의 옵션 설정
    - 쿠키 저장을 거부할 경우, 서비스 이용에는 문제가 없으나 맞춤형 서비스를 이용하실 수 없습니다.

## 8. 개인정보보호책임자 안내

* 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.
  + 개인정보보호 책임자
    - 성명: 최영진
    - 직책: 대표이사
    - 연락처: choi@cacheby.com
* 이용자는 회사 서비스를 이용하면서 발생한 모든 개인정보보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자로 문의하실 수 있습니다. 회사는 이용자의 문의에 대해 지체 없이 답변 및 처리해드릴 것입니다.

## 10. 개인정보의 안전성 확보 조치

* 회사는 개인정보보호법 제29조에 따라 다음과 같이 안전성 확보에 필요한 기술적, 관리적 및 물리적 조치를 하고 있습니다.
  + 개인정보 취급 직원의 최소화 및 교육
      - 개인정보를 취급하는 직원을 최소화하고, 주기적인 개인정보 보호 교육을 실시하여 개인정보를 관리하는 대책을 시행하고 있습니다.
  + 내부관리계획의 수립 및 시행
      - 개인정보의 안전한 처리를 위하여 내부관리계획을 수립하고 시행하고 있습니다.
  + 접속기록의 보관 및 위변조 방지
      - 개인정보 침해사고 발생 시 대응이 용이하도록 개인정보처리시스템에 접속한 기록(웹 로그, 요약정보 등)을 최소 1년 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 보안기능을 사용하고 있습니다.
  + 개인정보의 암호화
      - 이용자의 개인정보는 암호화 되어 저장 및 관리되고 있습니다. 또한 중요한 데이터는 저장 및 전송 시 암호화하여 사용하는 등의 별도 보안기능을 사용하고 있습니다.
  + 해킹 등에 대비한 기술적 대책
      - 회사는 해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인 갱신·점검을 하며, 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적/물리적으로 감시 및 차단하고 있습니다.
  + 개인정보에 대한 접근 제한
      - 개인정보를 처리하는 개인정보처리시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한 접근통제를 위한 조치를 하고 있습니다.

## 11. 정보주체의 권익침해에 대한 구제방법

+ 정보주체의 권익침해 관련 자세한 도움이 필요하시면 아래 기관에 문의하여 주시기 바랍니다.
  - 개인정보 침해신고센터 (한국인터넷진흥원 운영)
    * 소관업무 : 개인정보 침해사실 신고, 상담 신청
    * 홈페이지 : privacy.kisa.or.kr
    * 전화 : (국번없이) 118
    * 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
  - 개인정보 분쟁조정위원회
    * 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
    * 홈페이지 : www.kopico.go.kr
    * 전화 : (국번없이) 1833-6972
    * 주소 : (03171) 서울특별시 종로구 세종대로 209 정부서울청사 4층
  - 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr)
  - 경찰청 사이버안전국 : 182 (cyberbureau.police.go.kr)

## 12. 개인정보처리방침 변경에 관한 사항

* 이 개인정보처리방침은 시행일로부터 적용되며, 관련법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 지체없이 홈페이지 통하여 고지할 것입니다.
`,
  terms: `이용약관
============

제1장 총칙
------

##### 제 1 조(목적)

이 약관은 주식회사 데이터씨(이하 “회사”)가 운영하는 사이버몰에서 제공하는 서비스와 이를 이용하는 회원의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.

##### 제 2 조(용어의 정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다. 그리고 여기에서 정의되지 않은 이 약관상의 용어의 의미는 일반적인 거래관행에 따릅니다.

1. “사이버몰”이란 회사가 상품 또는 용역 등(일정한 시설을 이용하거나 용역을 제공받을 수 있는 권리를 포함하며, 이하 “상품 등”)을 회원에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 상품 등을 거래할 수 있도록 설정한 가상의 영업장(등 회사가 운영하는 웹사이트 및 모바일 웹, 앱 등을 모두 포함)을 의미합니다.

2. “회원”이라 함은 사이버몰에 회원등록을 한 자로서, 계속적으로 사이버몰에서 제공하는 서비스를 이용할 수 있는 자를 말합니다.

3. “아이디(ID)”라 함은 회원의 식별과 서비스 이용을 위하여 회원이 설정하고 회사가 승인하여 등록된 전자우편주소를 말합니다.

4. “비밀번호(Password)”라 함은 회원의 동일성 확인과 회원의 권익 및 비밀보호를 위하여 회원 스스로가 설정하여 사이버몰에 등록한 문자와 숫자 등의 조합을 말합니다.

5. “제휴사”란 회사와 계약을 체결하여 회원에게 상품 등을 거래하거나 각종 정보 및 혜택 등을 제공하거나 회원이 적립금을 사용, 교환할 수 있는 온라인 및 오프라인 업체를 의미합니다. 제휴사는 및 회사가 제공하는 개별 서비스 홈페이지에 고지되어 있으며, 회사 및 제휴사의 사정에 따라 해지 또는 추가될 수 있습니다.

##### 제 3 조(약관의 명시와 설명 및 개정)

① 회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 주소를 포함), 전화번호, 모사전송번호, 전자우편주소, 사업자등록번호, 통신판매업신고번호, 개인정보관리책임자 등을 회원이 쉽게 확인할 수 있도록 사이버몰의 초기 서비스 화면에 게시합니다. 다만, 약관의 구체적 내용은 회원이 연결화면을 통하여 볼 수 있도록 할 수 있습니다.

② 회사는 『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의 규제에 관한 법률』, 『전자문서 및 전자거래기본법』, 『전자금융거래법』, 『전자서명법』, 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『소비자기본법』 등 관련 법령을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.

③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 사이버몰의 화면에 그 적용일자 7일(다만, 회원에게 불리한 내용으로 변경하는 경우에는 30일) 이전부터 적용일자 전일까지 공지합니다.

④ 제3항에 의해 변경된 약관은 관련 법령에 특별한 규정 기타 부득이한 사유가 없는 한 그 적용일자 이전으로 소급하여 적용되지 아니합니다.

⑤ 제3항에 따라 공지된 적용일자 이후에 회원이 명시적으로 거부의사를 표명하지 않을 경우에는 개정된 약관에 동의하는 것으로 간주하며, 변경된 약관에 동의하지 않는 회원은 회원 탈퇴를 요청할 수 있습니다. 제3항의 조치에도 불구하고 약관의 개정 사실을 알지 못함으로써 발생하는 회원의 피해에 대하여 회사는 책임을 지지 않습니다.

⑥ 회사는 제공하는 서비스 내의 개별 서비스에 대한 별도의 약관 또는 이용조건을 둘 수 있으며 개별 서비스에서 별도로 적용되는 약관에 대한 동의는 회원이 개별 서비스를 최초로 이용할 경우 별도의 동의절차를 거치게 됩니다. 이 경우 개별 서비스에 대한 이용약관 등이 이 약관에 우선합니다.

⑦ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 『전자상거래 등에서의 소비자보호에 관한 법률』, 『약관의 규제에 관한 법률』, 공정거래위원회가 정하는 『전자상거래 등에서의 소비자 보호지침』 등 관련 법령 및 상관례에 따릅니다.

⑧ 이 약관의 규정이 대한민국의 강행법규와 상충되는 경우에는 그 강행법규에 따릅니다. 이 경우 다른 조항의 효력에는 영향을 미치지 아니합니다.

##### 제 4 조(서비스의 제공 및 변경)

① 회사는 다음 각 호와 같은 서비스를 제공합니다.

1. 전자상거래 서비스(통신판매중개서비스 포함) 및 이에 수반 되는 기타 서비스

2. 기타 회사가 정하는 서비스 또는 업무

② 회사는 상품 등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 상품 등의 내용을 변경할 수 있습니다. 이 경우에는 변경된 상품 등의 내용을 명시하여 현재의 상품 등의 내용을 게시한 곳에 즉시 공지합니다.

③ 회사가 제공하기로 회원과 계약을 체결한 서비스의 내용을 상품 등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우에는 그 사유를 회원에게 통지 가능한 주소로 즉시 통지합니다.

##### 제 5 조(서비스의 중단)

① 회사는 천재지변 또는 이에 준하는 불가항력, 컴퓨터 등 정보통신설비의 보수점검·교체, 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다

② 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 회원이 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.

③ 사업 종목의 전환, 사업의 종료 또는 포기, 회사의 폐업, 합병, 분할, 영업양도 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 회사는 제8조에 정한 방법으로 회원에게 통지하고 당초 회사에서 제시한 조건에 따라 회원에게 보상합니다. 다만, 회사가 보상기준 등을 고지하지 아니한 경우에는 회원의 적립금을 회사에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 회원에게 지급할 수 있습니다.

##### 제 6 조(회원가입 등)

① 회원 가입을 희망하는 자는 회사가 정한 가입양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로써 회원가입을 신청합니다.

② 회사는 제1항과 같이 회원으로 가입할 것을 신청한 자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다. 만약 회사가 회원가입신청의 승인을 거부하거나 유보하는 경우, 회사는 이를 제8조에 따라 회원에게 통지합니다.

1. 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우.

2. 회원의 요청에 의하여 탈퇴한 때로부터 1개월이 지나지 아니한 경우

3. 가입신청자가 기입한 회원정보에 명백한 허위 기재, 누락 또는 오기가 있는 경우

4. 회사가 본인확인 절차를 실시할 경우에 본인 확인이 되지 않거나 본인이 아님이 확인된 경우

5. 가입신청자가 만 14세 미만인 경우

6. 기타 가입신청자를 회원으로 등록하는 것이 사이버몰의 기술상 불가능하거나, 사이버몰의 운영 또는 유지·관리에 현저한 지장을 준다고 판단되는 경우

③ 회원가입계약의 성립시기는 회사의 승낙이 가입신청자에게 도달한 시점으로 합니다.

④ 회원은 회원정보에 변경이 있는 경우, 회원정보 수정 등의 방법으로 그 변경사항을 반영하여야 합니다. 회원정보 수정을 하지 않음으로써 발생하는 회원의 손해에 대하여 회사는 아무런 책임을 지지 않습니다.

⑤ 회사는 및 『청소년 보호법』 및 『화학물질 관리법』등 관련 법령에 따른 등급 및 연령제한 준수를 위하여 회원의 서비스 이용 또는 상품 등 구매를 제한하거나, 회원에게 나이 및 본인확인 등의 절차를 요구할 수 있습니다

##### 제 7 조(회원 탈퇴 및 자격 상실 등)

① 회원은 회사에 언제든지 탈퇴를 요청할 수 있으며, 회사는 회원의 회원탈퇴 요청 즉시 회원탈퇴를 처리합니다. 회원탈퇴 시 회원자격이 상실되며, 회사가 제공하는 각종 할인쿠폰, 이벤트 혜택 등이 소멸됩니다. 단, 회원탈퇴 시 소진되지 않은 적립금 등이 있는 경우 회원의 의사에 따라 적립금 등에 대한 권리를 포기한 것으로 간주하여, 탈퇴와 동시에 회원의 적립금 등은 전부 소멸됩니다.

② 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회원의 자격을 제한 또는 상실시킬 수 있으며, 회원 자격을 상실할 경우 적립금 등 회원으로서의 모든 혜택은 전부 소멸됩니다.

1. 회원정보에 허위 내용을 입력하거나 타인의 정보를 도용한 경우

2. 사이버몰을 이용하여 구입한 재화 등의 대금, 기타 사이버몰 이용과 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우

3. 다른 사람의 사이버몰 이용을 방해하거나 그 정보를 도용하는 등 전자상거래 질서를 위협하는 경우

4. 주소, 전자우편 등 회원정보를 잘못 입력하거나 변경하지 않는 등 회원의 귀책사유로 인하여 회사가 상당한 노력을 기울였음에도 불구하고 회원에게 통지 또는 연락을 할 수 없게 된 경우

5. 이 약관 제12조 회원의 의무를 위반하는 행위를 하는 경우

6. 이 약관의 규정 또는 회사의 이용정책 등을 위반하거나 법령 기타 공서양속에 반하는 행위를 하는 경우

③ 회사가 회원 자격을 제한 시킨 후 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원 자격을 상실시킬 수 있습니다.

④ 회사가 회원 자격을 상실시키는 경우에는 회원 등록을 말소하며, 이때 회사는 거래 안전을 위하여 해당 회원의 소유로 확인되는 아이디의 회원 등록을 일괄 말소할 수 있습니다. 이 경우 회사는 이를 제8조에 따라 회원에게 통지하고, 회원 등록 말소 전 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.

##### 제 8 조(회원에 대한 통지)

① 회사가 회원에 대한 통지를 하는 경우, 회원이 회사와 미리 약정하여 지정한 방법에 따라 전자우편, SMS, 전화, 팩스 등으로 할 수 있습니다.

② 회사는 불특정다수 회원에 대한 통지의 경우 7일 이상 사이버몰의 공지사항(고객센터)에 게시함으로써 개별 통지에 갈음할 수 있습니다. 다만, 회원 본인의 거래에 관련하여 중대한 영향을 미치는 사항에 대하여는 개별 통지합니다.

##### 제 9 조(정보의 제공 및 광고의 게재)

① 회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 게시판에 공지하거나 전자우편이나 SMS, 전화, 앱푸쉬 등의 방법으로 회원에게 제공할 수 있습니다. 그리고 회원은 법령에 따라 회사에게 부과된 의무이행을 위한 절차안내, 고객문의 등에 대한 답변, 기타 거래관련정보 등을 제외하고는 언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.

② 회사는 서비스의 운영과 관련하여 서비스 화면, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 포함된 전자우편 등을 수신한 회원은 수신거절을 할 수 있으며, 회사는 수신거절을 위한 방법을 회원에게 제공합니다.

##### 제 10 조(회사의 의무)

① 회사는 이 약관이 금지하거나 관련 법령 기타 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로 서비스를 제공하는 데 최선을 다합니다.

② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 회원의 개인정보(신용정보 포함)보호를 위한 보안시스템을 갖추어야 하며, 개인정보처리방침을 공시하고 준수합니다.

③ 회사는 회원이 동의하지 않는 영리목적의 광고성 전자우편, 앱푸쉬 등을 발송하지 않습니다.

④ 회사는 회원으로부터 제기되는 의견이나 불만이 객관적으로 정당하다고 인정될 경우에는 회원의 불만을 해결하기 위해 노력합니다.

##### 제 11 조(회원의 아이디 및 비밀번호에 대한 의무)

① 아이디와 비밀번호에 관한 관리책임은 회원 본인에게 있습니다.

② 회원은 자신의 아이디 및 비밀번호를 제3자에게 제공, 공개하거나 제3자가 이용하도록 해서는 안 됩니다.

③ 회원이 자신의 아이디 및 비밀번호의 유출 또는 제3자 사용에 대해 인지하고도 비밀번호를 변경하지 않은 경우 또는 이와 같은 사정을 회사에 통지 하지 않거나 회사의 조치에 응하지 않은 경우 등 회원이 본 조의 의무를 준수하지 않아 발생하는 모든 손실이나 손해 등 불이익에 대한 책임은 회원에게 있습니다.

##### 제 12 조(회원의 의무)

① 회원은 이 약관의 규정, 회사의 이용정책, 이용안내 사항 및 관련 법령 등을 준수하여야 하며, 기타 회사 업무에 방해되는 행위를 하여서는 안 됩니다.

② 회원은 다음 각 호의 행위를 하여서는 안 됩니다.

1. 회원이 회사가 제공하는 서비스를 이용하지 아니하고 판매자와 직접 거래하는 행위(이하 “직거래”) 또는 이를 유도하는 행위

2. 회사 또는 판매자의 판매 활동을 방해하거나 사이버몰을 이용하여 부당한 이득을 취하는 등 통상적인 전자상거래 관행에 부합하지 않는 거래상의 부정 행위

3. 상품의 판매 또는 용역의 제공을 가장한 현금 융통 등 『여신전문금융업법』, 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 및 기타 관계 법령에 위배되거나 비정상적인 결제 행위

4. 회사가 제공하는 서비스 이용방법에 의하지 아니하고 비정상적인 방법으로 서비스를 이용하거나 회사의 정보처리시스템에 접근하는 행위

5. 회사가 제공하는 서비스와 관련 없거나 비합리적인 요청, 공서양속에 반하는 행위 등으로 회사의 업무를 방해하는 행위

6. 기타 위 각 호에 준하여 회사 또는 제3자의 권리를 침해 또는 침해할 우려가 있거나, 전자상거래 질서를 위협하는 행위

③ 회사는 제2항을 위반한 회원에 대하여 계약 해제, 적립금 또는 할인쿠폰의 환수, 회원 자격의 제한, 현금 환불 보류 등의 조치 및 민∙형사 상의 법적 조치 등을 취할 수 있습니다.

##### 제 13 조(개인정보보호)

① 회사는 회원의 개인정보 수집 시 서비스 제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.

② 회사는 회원가입 시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에 본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다.

③ 회사는 회원의 개인정보를 수집·이용하는 때에는 당해 회원에게 그 목적을 고지하고 동의를 받습니다.

④ 회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용·제공단계에서 당해 회원에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.

⑤ 회사가 제3항과 제4항에 의해 회원의 동의를 받아야 하는 경우에는 개인정보 관리 책임자의 신원(소속, 성명 및 전화번호, 기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은 자, 제공목적 및 제공할 정보의 내용) 등 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』 에서 규정한 사항을 미리 명시하거나 고지해야 하며 회원은 언제든지 이 동의를 철회할 수 있습니다.

⑥ 회원은 언제든지 회사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류 정정을 요구할 수 있으며 회사는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 회원이 오류의 정정을 요구한 경우에는 회사는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.

⑦ 회사는 개인정보 보호를 위하여 회원의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 신용카드, 은행계좌 등을 포함한 회원의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 회원의 손해에 대하여 모든 책임을 집니다.

⑧ 회사 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.

⑨ 회사는 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에 관한 동의 거절 시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집·이용·제공에 관한 회원의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다.

⑩ 회사의 사이버몰(제2조 제1호에서 정한 범위 내) 이외의 링크된 사이버몰에서는 회사의 개인정보처리방침이 적용되지 않습니다. 링크된 사이버몰 및 상품 등을 제공하는 제3자의 개인정보 취급과 관련하여서는 해당 사이버몰 및 제3자의 개인정보처리방침을 확인할 책임이 회원에게 있으며, 회사는 이에 대하여 책임을 부담하지 않습니다.

⑪ 회사는 다음과 같은 경우에 법이 허용하는 범위 내에서 회원의 개인정보를 제3자에게 제공할 수 있습니다.

1. 수사기관이나 기타 정부기관으로부터 적법한 절차에 따른 정보제공을 요청 받은 경우

2. 회원이 관련 법령을 위반하는 등의 부정행위를 확인하기 위해 필요한 경우

3. 판매자 또는 배송업체 등에게 거래 및 배송 등에 필요한 최소한의 회원의 정보(성명, 주소, 전화번호)를 제공하는 경우

4. 구매가 성사된 때에 그 이행을 위하여 필요한 경우와 구매가 종료된 이후에도 반품, 교환, 환불, 취소 등을 위하여 필요한 경우

5. 기타 관련 법령에 의해 요구되는 경우

⑫ 기타 본 조에서 정하지 않은 사항은 회사가 마련한 “개인정보 처리방침”에 따릅니다.

##### 제 14 조(지급방법)

① 사이버몰에서 구매한 상품 등에 대한 대금지급 방법은 다음 각 호의 방법 중 가용한 방법으로 할 수 있습니다. 단, 회사는 회원의 지급방법에 대하여 상품 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다.

1. 폰뱅킹, 인터넷뱅킹 등의 각종 계좌이체

2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제

3. 온라인 무통장입금

4. 전자화폐에 의한 결제

5. 수령 시 대금지급

6. 회사와 계약을 맺었거나 회사가 인정한 상품권에 의한 결제

7. 기타 전자적 지급 방법에 의한 대금 지급 등

② 회원이 구매 대금의 결제와 관련하여 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 전적으로 회원이 부담합니다.

제2장 전자상거래 서비스
-------------

### 제 1 절 리테일 서비스

##### 제 15 조(구매신청 및 개인정보 제공 동의 등)

① 회원은 사이버몰 상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 회원이 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.

1. 상품 등의 검색 및 선택

2. 받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력

3. 약관내용, 청약철회권이 제한되는 서비스, 배송료, 설치비 등의 비용부담과 관련한 내용에 대한 확인

4. 이 약관에 동의하고 위 제3호의 사항을 확인하거나 거부하는 표시(예. 마우스 클릭)

5. 상품 등의 구매신청 및 이에 관한 확인 또는 회사의 확인에 대한 동의

6. 결제방법의 선택

② 회사가 제3자에게 회원의 개인정보를 제공할 필요가 있는 경우 실제 구매신청 시 회원의 동의를 받아야 하며, 회원가입 시 미리 포괄적으로 동의를 받지 않습니다. 이때 회사는 제공되는 개인정보 항목, 제공받는 자, 제공받는 자의 개인정보 이용목적 및 보유·이용기간 등을 회원에게 명시하여야 합니다.

③ 회사가 제3자에게 회원의 개인정보 처리(개인정보의 수집, 생성, 연계, 연동, 기록, 저장, 보유, 가공, 편집, 검색, 출력, 정정(訂正), 복구, 이용, 제공, 공개, 파기(破棄), 그 밖에 이와 유사한 행위를 포함) 업무를 위탁할 필요가 있는 경우 실제 구매신청 시 회원의 동의를 받아야 하며, 회원가입 시 미리 포괄적으로 동의를 받지 않습니다. 이때 회사는 개인정보 처리위탁을 받는 자, 개인정보 처리위탁을 하는 업무의 내용 등을 회원에게 명시하여야 합니다. 다만, 『정보통신망이용촉진 및 정보보호 등에 관한 법률』에 달리 정함이 있는 경우에는 그에 따릅니다.

##### 제 16 조(계약의 성립)

① 회사는 제19조와 같은 구매신청에 대하여 다음 각 호에 해당하면 계약을 승낙하지 않을 수 있습니다. 다만, 미성년자와 계약을 체결하는 경우에는 법정대리인의 동의를 얻지 못하면 미성년자 본인 또는 법정대리인이 계약을 취소할 수 있다는 내용을 고지하여야 합니다.

1. 신청 내용에 허위, 기재누락, 오기가 있는 경우

2. 제7조에 따라 회원 자격이 제한 또는 상실된 회원이 구매신청 한 경우

3. 구매신청 회원이 재판매의 목적으로 상품 등을 중복 구매하는 등 사이버몰의 거래질서를 방해한 경우

4. 관할청의 처분 등으로 상품 등의 판매가 중단된 경우

5. 기타 구매신청에 승낙하는 것이 회사의 기술상 현저히 지장이 있다고 판단하는 경우

② 회사의 승낙이 제21조 제1항의 수신확인통지 형태로 회원에게 도달한 시점에 계약이 성립한 것으로 봅니다.

③ 회사의 승낙의 의사표시에는 회원의 구매신청에 대한 확인 및 판매가능 여부, 구매신청의 정정, 취소 등에 관한 정보 등을 포함하여야 합니다.

④ 계약이 성립한 후 회사가 제1항 각 호의 사유를 발견한 경우 회사는 즉시 계약을 해제 또는 취소할 수 있으며, 계약 해제 또는 취소 시 회사는 회원이 상품 대금을 지급한 날로부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.

##### 제 17 조(수신확인통지·구매신청 변경 및 취소)

①회사는 회원의 구매신청이 있는 경우 회원에게 수신확인통지를 합니다.

②수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고, 회사는 배송 전에 회원의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만, 회원이 이미 대금을 지불한 경우에는 제24조의 청약철회 등에 관한 규정에 따릅니다.

##### 제 18 조(상품 등의 공급)

①회사는 회원과 상품 등의 공급시기에 관하여 별도의 약정이 없는 이상, 회원이 청약을 한 날로부터 7일 이내에 상품 등을 배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, 회사가 이미 상품 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다. 이때 회사는 회원이 상품 등의 공급절차 및 진행사항을 확인할 수 있도록 적절한 조치를 취합니다.

②회사는 회원이 구매한 상품 등에 대해 배송수단, 수단별 배송비용, 부담자, 수단별 배송예상기간 등을 명시합니다.

③회사와 회원 간에 상품 등의 인도 또는 제공 시기에 관하여 별도의 약정이 있는 경우에는 해당 약정이 이 약관에 우선합니다.

##### 제 19 조(환급)

회사는 회원이 구매신청한 상품 등이 품절 등의 사유로 인도 또는 제공할 수 없을 때에는 지체 없이 그 사유를 회원에게 통지하고, 사전에 상품 등의 대금을 받은 경우에는 대금을 받은 날로부터 3영업일 이내에 환급하거나 환급에 필요한 조치를 취합니다.

##### 제 20 조(청약철회 등)

① 회사와 상품 등의 구매에 관한 계약을 체결한 회원은 『전자상거래 등에서의 소비자보호에 관한 법률』 제13조 제2항에 따른 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 상품 등의 공급이 늦게 이루어진 경우에는 상품 등을 공급받거나 상품 등의 공급이 시작된 날을 말함)부터 7일 이내에는 청약을 철회할 수 있습니다. 다만, 청약철회에 관하여 『전자상거래 등에서의 소비자보호에 관한 법률』에 달리 정함이 있는 경우에는 동 법 규정에 따릅니다.

② 회원은 상품 등을 배송 받은 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.

1. 반품 요청기간이 지난 경우

2. 회원에게 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우(다만, 상품 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외함)

3. 회원의 사용 또는 일부 소비에 의하여 상품 등의 가치가 현저히 감소한 경우

4. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우

5. 복제 가능한 상품 등의 포장을 훼손한 경우

6. 주문 당시 재고가 없어, 해외 발주 상품의 경우

7. 회사가 상품 등의 청약철회 등의 제한에 관해 사전에 고지한 경우

8. 고객의 주문에 의해 제작되는 주문제작의 경우

③ 회원은 제1항 및 제2항의 규정에도 불구하고 상품 등의 내용이 표시∙광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해 상품 등을 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.

④ 회원은 제1항 또는 제3항에 따라 교환 신청을 하더라도 회사에 교환할 상품의 재고가 없는 경우에는 해당 상품 등의 교환을 받을 수 없습니다. 이 경우 해당 교환 신청은 반품으로 처리됩니다.

##### 제 21 조(청약철회 등의 효과)

① 회사는 회원으로부터 상품 등을 반환 받은 경우 3영업일 이내에 이미 지급받은 상품 등의 대금을환급합니다.이 경우 회사가 회원에게 상품 등의 대금 환급을 지연한 때에는 그 지연기간에 대하여 『전자상거래 등에서의 소비자보호에 관한 법률 시행령』 제21조의3에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.

② 회사는 위 대금을 환급함에 있어서 회원이 신용카드 또는 전자화폐 등의 결제수단으로 상품 등의 대금을 지급한 때에는 지체없이 당해 결제수단을 제공한 사업자로 하여금 상품 등의 대금의 청구를 정지하거나 결제를 취소하도록 요청합니다.

③ 회사는 이미 상품 등이 일부 사용 또는 일부 소비된 경우에는 일부 소비에 의하여 회원이 얻은 이익 또는 그 상품 등의 공급에 소요된 비용에 상당하는 금액으로서 아래의 각 호에 해당하는 금액의 지급을 회원에게 청구할 수 있습니다.

1. 상품 등의 사용으로 인하여 소모성 부품의 재판매가 곤란하거나 재판매가격이 현저히 하락하는 경우에는 당해 소모성 부품의 공급에 소요된 비용

2. 다수의 동일한 가분물로 구성된 상품 등의 경우에는 회원의 일부 소비로 인하여 소비된 부분의 공급에 소요된 비용

④ 청약철회 등의 경우 공급받은 상품 등의 반환에 필요한 제반 비용은 회원이 부담합니다. 회사는 회원에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만, 상품 등의 내용이 표시∙광고 내용과 다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 상품 등의 반환에 필요한 비용은 회사가 부담합니다.


### 제 2 절 마켓플레이스 서비스

##### 제 22 조(회원의 서비스 이용)

① 마켓플레이스 서비스와 관련하여 회사는 통신판매중개자로서 회원과 판매자 간의 자유로운 상품 등의 거래를 위한 시스템을 운영 및 관리, 제공할 뿐이므로, 회원은 상품 등을 구매하기 전에 반드시 판매자가 사이버몰 내에 작성한 상품 등의 상세 내용과 거래의 조건을 정확하게 확인해야 합니다. 구매하려는 상품 등의 내용과 거래의 조건을 확인하지 않고 구매하여 발생한 모든 손해는 회원 본인이 부담합니다.

② 회원은 이 약관 및 회사가 서비스 화면에서 공지하는 내용을 준수하여야 하고, 이 약관 및 공지 내용을 위반하거나 이행하지 않아 발생하는 모든 손해에 대하여 책임을 집니다.

③ 회원은 판매자와 상품 등 매매 절차에서 분쟁이 발생하면 분쟁의 해결을 위하여 성실히 임해야 하며, 분쟁해결의 불성실로 판매자와 회사에 손해가 발생하면 그에 대한 모든 책임을 부담합니다.

④ 회원은 매매대금의 결제와 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생하는 제반 문제에 대한 모든 책임을 부담합니다.

⑤ 회사는 회원의 매매대금 결제 시 해당 결제수단에 대하여 정당한 사용권한이 있는지 확인할 수 있고, 이에 대한 확인이 완료될 때까지 해당 거래의 진행을 중지할 수 있습니다.

⑥ 회사는 회원에게 서비스가 안전하게 제공될 수 있도록 각종 설비와 자료를 관리하고, 서비스가 제공 목적에 맞게 이용되고 있는지 여부를 확인합니다. 만약 회원이 이용 목적을 위반한 것으로 확인되면 회사는 그에 대한 소명을 회원에게 요청할 수 있고, 주문 취소 등 필요한 조치를 할 수 있습니다.

⑦ 회원은 회사가 회원의 서비스 이용 편의를 위하여 판매자 등으로부터 제공 받은 상품 등 관련 정보 기타 콘텐츠를 사이버몰을 통하여 제공하는 경우에도 상품 등의 구매 여부는 전적인 회원 본인의 판단과 책임으로 결정하여야 합니다. 이 경우 회사는 어떠한 경우에도 회원의 구매 결정에 대하여 책임을 부담하지 아니 합니다.

⑧ 미성년자가 사이버몰을 통하여 상품 등을 구매하는 경우에 법정대리인이 해당 계약에 대하여 동의하지 아니하면, 미성년자 본인 또는 법정대리인은 그 계약을 취소할 수 있습니다.

##### 제 23 조(결제대금예치서비스 이용)

① “결제대금예치서비스”라 함은 매매계약이 체결되고 회원이 대금을 결제하는 경우에, 회원의 결제대금 보호를 위하여 회사가 일정 기간 동안 결제대금을 예치하는 서비스를 말합니다.

② 회사는 회원과 판매자 간에 이루어지는 상품 등 매매의 안전성과 신뢰성을 높이고, 상품 등을 인수하기 전에 대금을 결제해야 하는 회원을 보호하기 위하여 결제대금예치서비스를 제공합니다.

③ 회사는 결제대금예치서비스의 제공과 관련하여 판매자 또는 회원을 대리하는 것이 아님은 물론, 상품 등의 매매와 관련하여 판매자 또는 회원의 의무를 대행하는 것도 아닙니다.

④ 회원은 결제대금예치서비스를 통하여 구매대금을 결제하는 과정에서 발생하는 송금수수료 등을 부담하여야 합니다.

⑤ 회원은 회사가 결제대금예치서비스를 제공하는 과정에서 발생하는 이자 등에 대하여 회사에게 그 반환을 청구할 수 없습니다.

⑥ 결제대금예치서비스는 제28조에 정한 바에 따라 구매확정 된 경우에 종료됩니다.

⑦ 회원은 결제대금예치서비스가 종료된 이후에 해당 구매 건에 대하여 청약철회, 취소, 해제, 무효 등의 사유가 발생한 경우 판매자와 직접 청약철회, 취소, 해제 및 환불 등에 관한 절차를 진행해야 합니다.

##### 제 24 조(배송 및 거래완료)

① 회사는 상품 등의 배송과 관련하여 판매자, 회원, 배송업체 등 관련 당사자 사이에 분쟁 등이 발생하는 경우에는 이에 관여하지 않으며 어떠한 책임도 부담하지 아니합니다. 이 경우 해당 분쟁 등은 관련 당사자가 직접 해결하여야 합니다.

② 회원은 구매한 상품 등의 배송이 완료되었을 때로부터 일정한 기간 내에 회사에 대하여 구매확정, 교환 또는 반품의 의사표시를 하여야 합니다.

③ 회사는 제2항의 구매확정 기간 내에 구매확정, 교환 또는 반품에 대한 회원의 의사표시가 없는 경우, 해당 거래에 대하여 회원의 구매확정 의사표시가 있는 것으로 간주하여 자동구매확정으로 처리할 수 있습니다.

④ 회원은 구매확정이 이루어진 경우에는 회사에 대하여 상품 등의 하자, 미수령, 반품 등의 사유로 이의를 제기할 수 없습니다. 구매확정 이후에 발생하는 환불, 교환 기타 판매자와 회원 간의 모든 문제는 거래 당사자인 판매자와 회원이 직접 해결해야 하며, 회사는 이에 개입하지 아니합니다.

##### 제 25 조(청약철회 등)

① 회원은 『전자상거래 등에서의 소비자보호에 관한 법률』 등 관련 법령에 따라 상품 등을 배송 받은 날로부터 7일 이내에 청약철회 등을 할 수 있습니다. 다만, 청약철회에 관하여 『전자상거래 등에서의 소비자보호에 관한 법률』에 달리 정함이 있는 경우에는 동 법 규정에 따릅니다.

② 회원은 제1항에도 불구하고 다음 각 호에 해당하는 경우에는 반품이나 교환을 요청할 수 없습니다.

1. 반품 요청기간이 지난 경우

2. 회원에게 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우(다만, 상품 등의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외함)

3. 회원의 사용 또는 일부 소비에 의하여 상품 등의 가치가 현저히 감소한 경우

4. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우

5. 복제 가능한 상품 등의 포장을 훼손한 경우

6. 주문 당시 재고가 없어, 해외 발주 상품의 경우

7. 회사가 상품 등의 청약철회 등의 제한에 관해 사전에 고지한 경우

8. 고객의 주문에 의해 제작되는 주문제작의 경우

9. 그 밖에 관련 법령에 따른 반품 제한 사유에 해당되는 경우

③ 회원은 제1항 및 제2항에도 불구하고 상품의 내용이 표시∙광고 내용과 다르거나 계약내용과 다르게 이행된 경우에는 해당 상품 등을 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.

④ 회사는 회원으로부터 교환 또는 반품의 의사표시를 받은 경우에는 즉시 그 사실을 판매자에게 통보합니다.

⑤ 회원은 제1항 또는 제3항에 따라 교환 신청을 하더라도 판매자에게 교환할 상품의 재고가 없는 경우에는 해당 상품 등의 교환을 받을 수 없습니다. 이 경우 해당 교환 신청은 반품으로 처리됩니다.

⑥ 반품이나 교환에 필요한 배송비 및 기타 비용은 귀책사유가 있는 당사자가 부담합니다. 이 경우 상품 등의 하자 또는 오배송으로 인한 반품이나 교환의 경우에는 판매자가 그 비용을 부담하나, 회원의 단순 변심으로 인한 반품이나 교환의 경우에는 회원이 그 비용을 부담합니다.

⑦ 판매자는 회원이 배송상의 문제로 손해를 입은 경우에는 그에 대한 책임을 부담합니다.

⑧ 회사는 판매자가 회원의 결제완료에 대한 통지를 받은 이후에도 상당 기간 배송 절차 등을 이행하지 아니하여 회원이 청약철회 등을 하거나 개별적인 정책으로 미리 정한 자동환불처리 사안에 해당하는 경우에는 해당 거래를 취소하고 결제대금예치서비스 이용 중인 결제대금을 회원에게 환불할 수 있습니다.

⑨ 판매자가 회원의 교환 또는 반품 신청에 대하여 적극적으로 임하지 않거나 이를 지연하는 경우, 회사는 회원에게 그 교환 또는 반품 신청의 사유를 파악하여 정당한 사유가 있는 경우에는 해당 거래를 취소하는 한편, 예치 중인 결제대금을 회원에게 환불할 수 있습니다. 다만 회원의 교환 또는 반품신청에 정당한 사유가 없는 경우에는 그러하지 아니합니다.

⑩ 회원이 교환 또는 반품신청을 한 날로부터 14일이 지날 때까지 이미 수령한 상품을 판매자에게 반환하지 아니 하거나 전화, 전자우편 등으로 연락되지 아니하는 경우, 해당 회원의 교환 또는 반품 신청은 효력을 상실합니다.

⑪ 회사는 청약철회 등으로 인하여 결제대금을 환불하는 경우에는 그 청약철회 등을 한 날(단, 상품 등이 배송된 경우에는 판매자가 상품 등을 반환 받은 날)로부터 3영업일 이내에 환불에 필요한 조치를 합니다. 신용카드로 결제가 이루어진 경우 환불은 해당 신용카드 결제 취소를 통해서만 가능하고, 어떠한 경우에도 현금으로 환불되지는 아니합니다.

##### 제 26 조(금지행위)

① 판매자와 회원이 회사가 제공하는 서비스를 이용하지 아니하고 직접 거래하는 행위(직거래)는 거래의 안전을 위하여 금지됩니다. 이 경우 직거래를 통하여 발생한 제반 문제에 대한 책임은 거래 당사자들에게 있으며 회사는 이에 대해 어떠한 책임도 부담하지 아니 합니다.

② 제1항 이외에 금지되는 회원의 행위에 대하여는 이 약관 제12조의 규정에 따릅니다.

##### 제 27 조(회사의 면책)

① 회사는 통신판매중개자로서 회원과 판매자 간의 자유로운 상품 등의 거래를 위한 시스템을 운영 및 관리, 제공할 뿐 회원 또는 판매자를 대리하지 않으며, 회원과 판매자 사이에 성립된 거래와 관련된 책임과 회원이 제공한 정보에 대한 책임은 해당 회원이 직접 부담하여야 합니다.

② 회사는 판매자가 등록한 상품 등의 내용과 거래조건에 대해서 어떠한 보증이나 대리를 하지 않으며, 회원은 전적으로 본인의 책임 하에 상품 등을 구매해야 합니다.

③ 회사는 회원과 판매자 간의 모든 행위(거래행위 포함)와 관련하여 판매의사 또는 구매의사의 존부 및 진정성, 등록 상품의 품질, 완전성, 안정성, 적법성 및 타인의 권리에 대한 비침해성, 회원 또는 판매자가 입력하는 정보 및 그 정보를 통하여 연결된 웹사이트에 게재된 자료의 진실성 또는 적법성 등 일체에 대하여 보증하지 아니하며, 이와 관련된 일체의 위험과 책임은 해당 당사자들이 부담합니다.

④ 회사는 회원 및 판매자의 귀책사유로 서비스 이용에 장애가 발생하는 것에 대하여 책임을 부담하지 아니합니다.

⑤ 회사는 회원이 본인의 개인정보를 타인에게 유출하거나 제공하여 발생하는 피해에 대하여 책임을 부담하지 아니합니다.

⑥ 회사는 천재지변, 컴퓨터 등 정보통신설비의 보수, 점검, 교체, 고장 및 통신두절 등의 사유가 발생한 경우에는 서비스 제공을 일시적으로 중단할 수 있으며, 이와 관련하여 고의 또는 과실이 없는 한 어떠한 책임도 부담하지 아니합니다.

⑦ 회원과 판매자 간 거래에 있어서 분쟁 발생 시 1차적으로 회사가 중재하고 회원과 판매자는 이에 협조한다. 이 때 회사는 위 분쟁으로 인하여 제3자(PG사를 포함)에게 피해가 가지 않도록 적극 중재한다.

제3장 기타 사항
---------

##### 제 28 조(연결몰과 피연결몰의 관계)

① 상위 사이버몰과 하위 사이버몰이 하이퍼링크(예 : 하이퍼링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된 경우, 전자를 연결몰이라고 하고, 후자를 피연결몰이라고 합니다.

② 연결몰은 피연결몰이 독자적으로 제공하는 상품 등에 의하여 회원과 행하는 거래에 대해서 보증책임을 지지 않는다는 뜻을 연결몰의 초기화면 또는 연결되는 시점의 팝업화면으로 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다.

##### 제 29 조(저작권의 귀속 및 이용제한)

① 회사가 작성한 저작물에 대한 저작권 및 기타 지식재산권은 회사에 귀속합니다.

② 회사는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권한만을 부여하며, 회원은 서비스를 이용함으로써 얻은 정보 중 회사에게 지식재산권이 귀속된 정보를 회사의 사전 승낙 없이 복제, 송신, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리 목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.

##### 제 30 조(회원의 게시물)

① 회원이 사이버몰에 등록 또는 게시한 게시물에 대한 모든 책임은 회원에게 있으며, 회사는 회원의 게시물이 다음 각 항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있고, 이에 대하여 회사는 어떠한 책임도 지지 않습니다.

1. 타인을 모욕, 비방, 비하하거나 타인의 명예를 훼손하는 게시물

2. 범죄 및 불법 행위에 악용될 수 있는 정보를 담고 있는 게시물

3. 타인의 저작권, 상표권 등 권리를 침해하는 게시물

4. 음란물 또는 일반인의 성적 굴욕감이나 수치심을 유발할 수 있는 내용의 게시물(그러한 내용이 담긴 웹사이트, 앱 등으로 연결될 수 있는 게시물을 포함)

5. 어린이와 청소년의 정신적, 신체적 건강을 해칠 우려가 있는 선정적인 내용을 담은 게시물

6. 특정인의 개인정보가 노출된 게시물

7. 특정 상품 등을 소개하여 판매하거나, 이를 구매, 사용하도록 권하거나 연락을 유도하는 등 직간접적으로 영리추구를 위한 내용을 담고 있는 게시물

8. 사이버몰의 이용 목적에 부합하지 않거나 해당 서비스의 취지와 무관한 내용의 게시물

9. 악성코드나 스파이웨어 등이 실행되어 다른 회원, 회사, 판매자 기타 제3자의 시스템 성능 저하, 개인정보 유출 등의 피해를 줄 수 있는 악의적인 코드를 담고 있는 게시물

10. 정당한 사유 없이 회사의 영업을 방해하는 내용의 게시물

11. 기타 이 약관 또는 법령에 위배되거나 공서양속에 반하는 내용의 게시물

② 회원이 탈퇴하는 경우, 탈퇴 전에 작성한 게시물(댓글 포함)은 삭제되지 않습니다. 회원 탈퇴 시 회원정보가 삭제되어 작성자 본인을 확인할 수 없게 되므로 게시물에 대한 편집 또는 삭제가 원천적으로 불가하며, 게시물의 삭제를 원하는 회원은 반드시 회원 탈퇴 이전에 해당 게시물을 삭제하여야 합니다.

③ 회원이 작성한 게시물은 상품 등의 연구개발, 판촉, 홍보 등의 목적으로 회사가 제휴한 타사에 복제, 배포, 전송 또는 전시될 수 있으며, 본질적인 내용에 변경을 가하지 않는 범위 내에서 수정, 편집될 수 있습니다. 이 경우 회사는 해당 게시물로부터 회원의 개인정보가 식별되지 않도록 필요한 조치를 합니다.

##### 제 31 조(게시물의 관리)

① 회원의 게시물이 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보 보호법』 및 『저작권법』등 관련 법령에 위반되는 내용을 포함하는 경우, 권리자는 관련 법령이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련 법령에 따라 조치를 취하여야 합니다.

② 회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련 법령에 위반되는 경우에는 관련 법령에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다.

③ 이 조에 따른 세부절차는 『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보 보호법』 및 『저작권법』등 관련 법령이 규정한 범위 내에서 회사가 정한 게시중단요청서비스에 따릅니다.

##### 제 32 조(회사의 면책)

① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.

② 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.

③ 회사는 회원이 서비스를 이용하여 기대하는 수익을 상실한 것에 대하여 책임을 지지 않으며, 그 밖의 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않습니다.

④ 회사는 회원이 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관해서는 책임을 지지 않습니다.

⑤ 회사는 회원 간 또는 회원과 제3자 상호 간에 회사의 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.

⑥ 회사는 무료로 제공되는 서비스 이용과 관련하여 관련 법령에 특별한 규정이 없는 한 책임을 지지 않습니다.

##### 제 33 조(분쟁해결)

회사는 회원으로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 즉시 통보합니다.

##### 제 34 조(재판권 및 준거법)

① 이 약관의 해석 및 회사와 회원 간의 분쟁에 대하여는 대한민국의 법률을 적용합니다.

② 이 약관 및 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생하여 소송이 제기되는 경우에는 『민사소송법』에 따라 관할법원을 정합니다.

##### 부칙

1. 이 약관은 2019년 8월 1일부터 시행합니다.
`,
};

export default data;



// WEBPACK FOOTER //
// ./src/components/policy/policyData.js